import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import apiEndpoints from "../../apiConfig";

const FamilyInformation = ({ form, setField, isMobile, showErrors }) => {
  console.log("Rendering FamilyInformation with form:", form);
  const [options, setOptions] = useState({
    familyType: [],
  });

  const fetchFieldOptions = async (key, table, parentTable, parentId) => {
    try {
      let url = `${apiEndpoints.getOptions}?table=${table}`;
      if (parentTable && parentId)
        url += `&parent_table=${parentTable}&parent_id=${parentId}`;

      const res = await fetch(url);
      const data = await res.json();

      if (Array.isArray(data)) {
        setOptions((prev) => ({ ...prev, [key]: data }));
      } else {
        console.error("API returned unexpected data:", data);
        setOptions((prev) => ({ ...prev, [key]: [] }));
      }
    } catch (err) {
      console.error("Failed to fetch options for", table, err);
      setOptions((prev) => ({ ...prev, [key]: [] }));
    }
  };
  useEffect(() => {
    // Always fetch family type options once
    fetchFieldOptions("familyType", "family_type");
  }, []);

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Family Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} width={isMobile ? "100%" : "48%"}>
          <Autocomplete
            options={options.familyType}
            getOptionLabel={(option) => option?.name || ""}
            value={
              options.familyType.find((c) => c.name === form.family_type) ||
              null
            }
            onChange={(_, v) => {
              if (v) {
                setField("family_type", v.name); // for UI only
              } else {
                setField("family_type", "");
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Family Type"
                fullWidth
                error={showErrors && !form.family_type}
                helperText={
                  showErrors && !form.family_type
                    ? "Family Type is required"
                    : ""
                }
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            select
            fullWidth
            label="Family Status"
            value={form.family_status}
            onChange={(e) => setField("family_status", e.target.value)}
            error={showErrors && !form.family_status}
            helperText={
              showErrors && !form.family_status
                ? "Family status is required"
                : ""
            }
          >
            <MenuItem value="Middle Class">Middle Class</MenuItem>
            <MenuItem value="Upper Middle Class">Upper Middle Class</MenuItem>
            <MenuItem value="Rich">Rich</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} md={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Father Name"
            value={form.father_name}
            onChange={(e) => setField("father_name", e.target.value)}
            error={showErrors && !form.father_name}
            helperText={
              showErrors && !form.father_name ? "Father Name is required" : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Father Occupation"
            value={form.father_occupation}
            onChange={(e) => setField("father_occupation", e.target.value)}
            error={showErrors && !form.father_occupation}
            helperText={
              showErrors && !form.father_occupation
                ? "Father Occupation is required"
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Mother Name"
            value={form.mother_name}
            onChange={(e) => setField("mother_name", e.target.value)}
            error={showErrors && !form.mother_name}
            helperText={
              showErrors && !form.mother_name ? "Mother Name is required" : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Mother Occupation"
            value={form.mother_occupation}
            onChange={(e) => setField("mother_occupation", e.target.value)}
            error={showErrors && !form.mother_occupation}
            helperText={
              showErrors && !form.mother_occupation
                ? "Mother Occupation is required"
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} md={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="No. of Brothers"
            type="number"
            value={form.no_of_brothers ?? 0}
            onChange={(e) => {
              const value = e.target.value;
              // allow empty input or numbers >= 0
              if (value === "") {
                setField("no_of_brothers", ""); // keep empty string while typing
              } else if (!isNaN(Number(value)) && Number(value) > -1) {
                setField("no_of_brothers", Number(value));
              } else {
                setField("no_of_brothers", 0);
              }
            }}
            inputProps={{ min: 0 }}
          />
        </Grid>

        <Grid item xs={12} md={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="No. of Sisters"
            type="number"
            value={form.no_of_sisters ?? 0}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                setField("no_of_sisters", "");
              } else if (!isNaN(Number(value)) && Number(value) > -1) {
                setField("no_of_sisters", Number(value));
              }
            }}
            inputProps={{ min: 0 }}
          />
        </Grid>

        <Grid item xs={12} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="About Family"
            value={form.about_family}
            onChange={(e) => setField("about_family", e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FamilyInformation;
